import React, { useContext, useState } from "react";
import { AuthContext } from "../../../context/authContext";
import {
  Box,
  Typography,
  Container,
  Grid,
  FormControlLabel,
  FormControl,
  Paper,
  SvgIcon,
} from "@mui/material";

import {
  FixedHeader,
  ActionButton,
  BackButton,
  CustomCheckbox,
} from "./styled";

import questionsData from "../../../utils/questionsData.json";
import TestResults from "./resultado";

import { colors } from "../../../theme/colors";

import plecaHeader from "../../../img/tester/header-retos-bi-en-linea.webp";

import { ReactComponent as ArrowButton } from "../../../img/tester/svg/arrow-right-circle.svg";
import { ReactComponent as ArrowBackButton } from "../../../img/tester/svg/izq-ico-fundacion-bi.svg";

import { FullScreenWrapper } from "../../Entry/styled";

import Header from "../../../components/common/Header";
import Footer from "../../../components/common/Footer";

export default function FinancialTest() {
  const [currentPage, setCurrentPage] = useState(0);
  const [answers, setAnswers] = useState({});
  const [section1Score, setSection1Score] = useState(0);
  const [section2Score, setSection2Score] = useState(0);
  const [showResults, setShowResults] = useState(false);
  const { idCliente, logout } = useContext(AuthContext);
  const isLoggedIn = !!idCliente;

  // Traer la preguntas
  const allQuestions = questionsData.sections.flatMap((section) =>
    section.questions.map((question) => ({
      ...question,
      sectionId: section.id,
      sectionTitle: section.title,
      optionLabels: section.optionLabels,
    })),
  );

  const questionsPerPage = 2;
  const totalPages = Math.ceil(allQuestions.length / questionsPerPage);

  const handleAnswerChange = (questionId, value, isChecked) => {
    let newAnswers = { ...answers };

    if (isChecked) {
      newAnswers[questionId] = parseInt(value);
    } else {
      delete newAnswers[questionId];
    }

    setAnswers(newAnswers);

    const previousScore =
      answers[questionId] !== undefined
        ? calculateQuestionScore(questionId, answers[questionId])
        : 0;
    const newScore = isChecked
      ? calculateQuestionScore(questionId, parseInt(value))
      : 0;

    const currentQuestion = allQuestions.find((q) => q.id === questionId);
    if (currentQuestion) {
      if (currentQuestion.sectionId === 1) {
        setSection1Score((prev) => prev - previousScore + newScore);
      } else if (currentQuestion.sectionId === 2) {
        setSection2Score((prev) => prev - previousScore + newScore);
      }
    }
  };

  const calculateQuestionScore = (questionId, value) => {
    const currentQuestion = allQuestions.find((q) => q.id === questionId);
    if (!currentQuestion || !currentQuestion.scoring) return 0;

    const selectedOption = currentQuestion.scoring.find(
      (option) => option.value === value,
    );
    return selectedOption ? selectedOption.score : 0;
  };

  const handleNext = () => {
    if (currentPage < totalPages - 1) {
      setCurrentPage((prev) => prev + 1);
    } else {
      setShowResults(true);
    }
  };

  const handlePrevious = () => {
    if (currentPage > 0) {
      setCurrentPage((prev) => prev - 1);
    }
  };

  // Función para obtener el número de pregunta global
  const getQuestionNumber = (questionId) => {
    return allQuestions.findIndex((q) => q.id === questionId) + 1;
  };

  // Acción que muestra los resultados
  if (showResults) {
    return (
      <TestResults
        section1Score={section1Score}
        section2Score={section2Score}
      />
    );
  }

  // Obtener las preguntas de la página actual
  const startIndex = currentPage * questionsPerPage;
  const endIndex = startIndex + questionsPerPage;
  const currentQuestions = allQuestions.slice(startIndex, endIndex);

  // Obtener la sección actual
  const currentSection =
    currentQuestions.length > 0 ? currentQuestions[0] : null;

  const areAllAnswered = currentQuestions.every(
    (q) => answers[q.id] !== undefined,
  );
  const isLastPage = currentPage === totalPages - 1;

  return (
    <FullScreenWrapper>
      {!isLoggedIn && <Header />}
      <FixedHeader>
        <Container maxWidth="lg">
          <Grid container spacing={4} alignItems="center">
            <Grid item xs={12} md={4}>
              <Box
                display="flex"
                justifyContent="center"
                sx={{ marginLeft: { xs: "2rem", md: "0rem" } }}
              >
                <img
                  src={plecaHeader}
                  alt="Descripción"
                  sx={{
                    width: "90%",
                    maxWidth: 350,
                    height: "auto",
                  }}
                />
              </Box>
            </Grid>
            <Grid
              item
              xs={12}
              md={8}
              sx={{ marginLeft: { xs: "2rem", md: "0rem" } }}
            >
              <Typography
                variant="h4"
                sx={{
                  color: colors.secondary,
                  fontWeight: "700",
                  mb: 1,
                  fontSize: { xs: "1.4rem", md: "1.5rem" },
                }}
              >
                Bienvenido al Test Financiero
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: "14px",
                  color: colors.white.main,
                }}
              >
                <strong>Instrucciones:</strong> Lee con atención las preguntas y
                selecciona una de las opciones que te mejor te describan.
              </Typography>
              <Typography
                variant="h4"
                sx={{
                  color: colors.orange.secondary,
                  mt: 4,
                  fontSize: { xs: "1.8rem", md: "2.1rem" },
                }}
              >
                {currentSection ? currentSection.sectionTitle : ""}
              </Typography>
            </Grid>
          </Grid>
        </Container>
      </FixedHeader>

      {/* Contenido de preguntas */}
      <Container maxWidth="lg" sx={{ py: 6 }}>
        <Grid container spacing={4}>
          <Grid item xs={12}>
            <Grid container spacing={2} sx={{ mb: 3 }}>
              <Grid item xs={12} md={4}></Grid>
              <Grid item xs={12} md={8}>
                <Grid
                  container
                  spacing={2}
                  sx={{ display: { xs: "none", md: "flex" } }}
                >
                  {currentSection &&
                    currentSection.optionLabels &&
                    currentSection.optionLabels.map((label, index) => (
                      <Grid
                        item
                        xs={currentSection.optionLabels.length === 5 ? 2.4 : 3}
                        key={index}
                      >
                        <Typography
                          variant="body1"
                          sx={{
                            color: colors.orange.light,
                            textAlign: "center",
                            fontSize: { xs: "0.8rem", md: "1rem" },
                            fontWeight: "800",
                          }}
                        >
                          {label}
                        </Typography>
                      </Grid>
                    ))}
                </Grid>
              </Grid>
            </Grid>

            {currentQuestions.map((questionData, index) => (
              <Paper
                key={questionData.id}
                elevation={1}
                sx={{
                  p: 3,
                  mb: 2,
                  backgroundColor: "transparent",
                  boxShadow: "none",
                }}
              >
                <Grid container spacing={2} alignItems="center">
                  <Grid item xs={12} md={4}>
                    <Typography
                      variant="body1"
                      sx={{
                        color: {
                          xs: colors.primary,
                          md: colors.primary.light,
                        },
                        fontSize: { xs: "1rem", md: "1rem" },
                        lineHeight: 1.3,
                        fontWeight: "700",
                      }}
                    >
                      {/* Agregamos el número de pregunta aquí */}
                      <strong>
                        {getQuestionNumber(questionData.id)}.
                      </strong>{" "}
                      {questionData.question}
                    </Typography>
                  </Grid>

                  {/* Opciones de respuesta */}
                  <Grid item xs={12} md={8}>
                    <FormControl component="fieldset" sx={{ width: "100%" }}>
                      <Grid
                        container
                        spacing={2}
                        sx={{ display: { xs: "none", md: "flex" } }}
                      >
                        {questionData.scoring.map((option) => (
                          <Grid
                            item
                            xs={questionData.scoring.length === 5 ? 2.4 : 3}
                            key={option.value}
                          >
                            <FormControlLabel
                              control={
                                <CustomCheckbox
                                  checked={
                                    answers[questionData.id] === option.value
                                  }
                                  onChange={(e) =>
                                    handleAnswerChange(
                                      questionData.id,
                                      option.value,
                                      e.target.checked,
                                    )
                                  }
                                />
                              }
                              label=""
                              sx={{
                                margin: 0,
                                width: "100%",
                                height: "100%",
                                justifyContent: "center",
                                alignItems: "center",
                              }}
                            />
                          </Grid>
                        ))}
                      </Grid>

                      {/* Preguntas en mobile */}
                      <Box sx={{ display: { xs: "block", md: "none" } }}>
                        {questionData.scoring.map((option, optionIndex) => (
                          <FormControlLabel
                            key={option.value}
                            control={
                              <CustomCheckbox
                                checked={
                                  answers[questionData.id] === option.value
                                }
                                onChange={(e) =>
                                  handleAnswerChange(
                                    questionData.id,
                                    option.value,
                                    e.target.checked,
                                  )
                                }
                              />
                            }
                            label={
                              <Typography
                                variant="body2"
                                sx={{
                                  color: {
                                    xs: colors.primary,
                                    md: colors.orange.main,
                                  },
                                  fontWeight: "600",
                                  ml: 1,
                                }}
                              >
                                {currentSection.optionLabels[optionIndex]}
                              </Typography>
                            }
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              width: "100%",
                              mb: 1,
                              mx: 0,
                            }}
                          />
                        ))}
                      </Box>
                    </FormControl>
                  </Grid>
                </Grid>
              </Paper>
            ))}

            {/* Botones de navegación */}
            <Box
              display="flex"
              flexDirection="column"
              alignItems="center"
              sx={{ mt: 4, gap: 3 }}
            >
              <Box display="flex" alignItems="center" gap={1}>
                {Array.from({ length: totalPages }, (_, index) => (
                  <Box key={index}>
                    {index === currentPage ? (
                      <ActionButton
                        id={`Btn-test-siguiente-retos-${index + 1}`}
                        onClick={handleNext}
                        disabled={!areAllAnswered}
                        endIcon={
                          <SvgIcon
                            component={ArrowButton}
                            inheritViewBox
                            sx={{ fontSize: "2rem" }}
                          />
                        }
                      >
                        {isLastPage ? "Finalizar" : "Siguiente"}
                      </ActionButton>
                    ) : index === currentPage - 1 && currentPage > 0 ? (
                      <BackButton
                        onClick={handlePrevious}
                        sx={{
                          minWidth: "18px",
                          height: "18px",
                        }}
                      >
                        <SvgIcon
                          component={ArrowBackButton}
                          inheritViewBox
                          sx={{ fontSize: ".8rem" }}
                        />
                      </BackButton>
                    ) : (
                      <Box
                        sx={{
                          width: "20px",
                          height: "20px",
                          borderRadius: "50%",
                          backgroundColor:
                            index < currentPage
                              ? colors.primary
                              : colors.primary,
                          transition: "background-color 0.3s ease",
                          cursor: index < currentPage ? "pointer" : "default",
                        }}
                        onClick={
                          index < currentPage
                            ? () => setCurrentPage(index)
                            : undefined
                        }
                      />
                    )}
                  </Box>
                ))}
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Container>

      {!isLoggedIn && <Footer />}
    </FullScreenWrapper>
  );
}
